export default [
  {
    key: 'id',
    title: '任务ID',
    fixed: 'left',
    width: 40
  },
  {
    key: 'taskType',
    title: '类型',
    width: 68
  },
  {
    key: 'imageNames',
    title: '素材',
    width: 78,
    overflow: true
  },
  {
    key: 'gameNames',
    title: '游戏',
    width: 108,
    overflow: true
  },
  {
    key: 'account',
    title: '账号',
    width: 100,
    overflow: true
  },
  {
    key: 'funcObject',
    title: '作用对象',
    width: 108,
    overflow: true
  },
  {
    key: 'opType',
    title: '操作类型',
    width: 56
  },
  {
    key: 'taskStatus',
    title: '任务状态'
  },
  {
    key: 'result',
    title: '结果',
    width: 140,
    overflow: true
  },
  {
    key: 'createTime',
    title: '提交时间',
    width: 104
  },
  {
    key: 'opIdName',
    title: '创建人员',
    width: 60
  },
  {
    key: 'control',
    title: '操作',
    width: 110
  }
]
